export function formatCurrency(n: number, currency: string = 'CZK') {
	return new Intl.NumberFormat('cs', {
		style: 'currency',
		currency: currency,
		minimumFractionDigits: 0,
	}).format(n)
}

export const getPlaneImage = (plane?: { value: number }) => {
	if (!plane)
		return "plane_blue.png"

	switch (plane.value) {
		case 0:
			return "plane_white.png"
		case 1:
			return "plane_blue.png"
		case 2:
			return "plane_red.png"
	}

	return "plane_blue.png"
}
